export const MAX_SUCCESSFUL_REFRESHES_DURING_INTERVAL = 3;
export const RECENT_REFRESHES_THRESHOLD_MS = 3000;
